import { Module } from 'vuex';

import { RootState, EditableStatus, ListStatus } from '@/store/types';
import Pagination from '@/store/models/pagination';
import { CategoryState } from '@/store/modules/categories/types';

import actions from './actions';
import mutations from './mutations';
import getters from './getters';

export const getInitialState = (): CategoryState => ({
  /**
   * List
   */
  status: ListStatus.Loading,
  list: [],
  listPagination: new Pagination(),

  /**
   * All Categories
   */
  allFilters: {},
  allList: [],
  allStatus: ListStatus.Loading,

  /**
   * Edit
   */
  editableStatus: EditableStatus.Loading,
  translationsStatus: EditableStatus.Loaded,
});

export const state: CategoryState = getInitialState();

const categories: Module<CategoryState, RootState> = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};

export default categories;
